export enum DealStatus {
    INITIAL_OUTREACH = "Initial Outreach",
    HUM_MEETINGS_UNDERWAY = "Hum meetings underway",
    MANAGEMENT_MEETINGS_UNDERWAY = "Management meetings underway",
    RECEIVING_TERM_SHEETS = "Receiving term sheets",
    TERM_SHEET_SENT = "Term sheet sent",
    TERM_SHEET_SIGNED = "Term sheet signed",
    FUNDED = "Funded",
    PAUSED = "Paused",
    TERMINATED = "Terminated",
    UNDISCLOSED = "Undisclosed",
    CLOSED = "Closed",
}

export const dealStatusOptions = Object.values(DealStatus).map((status) => ({
    label: status,
    value: status,
}));
